<template>
  <div class="accordion-group" ref="accordionGroup">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeOther(component: any) {
      if (this.multiple) return;
      // Vue 3: $children is removed, use refs or provide/inject instead
      // For now, we'll use a simple approach with slots
      const accordionGroup = this.$refs.accordionGroup as HTMLElement;
      if (accordionGroup) {
        // Find all accordion components in the slot and close them
        const accordions = Array.from(accordionGroup.querySelectorAll('.accordion'));
        accordions.forEach((accordion) => {
          const componentInstance = (accordion as any).__vueParentComponent;
          if (componentInstance && componentInstance.ctx !== component) {
            if (componentInstance.ctx.isExtended !== undefined) {
              componentInstance.ctx.isExtended = false;
            }
          }
        });
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.accordion-group {
  .accordion + .accordion {
    margin-top: 10px;
  }
}
</style>
